import React from 'react'
import s from './MenuSubCategoriesGE.less'
import { selectSubCategoriesMenu } from '../../store/poiassets/poiassets.selectors'
import MenuSubCategoryItem from './MenuSubCategoryItem'
import MenuApplicationItem from './MenuApplicationItem'
import useTimeout from '../utils/useTimeout'
import usePublisherBarreCategorieTag from './usePublisherBarreCategorieTag'
import { useSelectorWithProps } from '../utils/react-redux'
import CategorySubMenuStyle from './CategorySubMenuStyle'
import classNames from 'classnames'
import AdMenu from '../advertising/AdMenu'

const MenuSubCategoriesGE = ({ categoryId, onMouseLeaveMenu }) => {
  const { subcategories, apps, color } = useSelectorWithProps(selectSubCategoriesMenu, { id: categoryId })
  const [setMouseOverTimeout, clearMouveOverTimeout] = useTimeout(150)

  usePublisherBarreCategorieTag(categoryId)

  if (!categoryId) return null

  const onMouseOver = e => {
    clearMouveOverTimeout()
  }

  const onMouseOut = e => {
    setMouseOverTimeout(() => {
      onMouseLeaveMenu()
    })
  }

  const columnCount = 2 + Number(subcategories.length > 5) + Number(apps.length > 5)

  return (
    <div className={s.container} onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
      <div className={classNames(s.itemsWrapper, `cols-${columnCount}`)}>
        <ul className={s.items}>
          {subcategories.map(({ id, iconId, label, rubricIds }) => (
            <MenuSubCategoryItem
              key={`subcategory-${id}`}
              id={id}
              iconId={iconId}
              label={label}
              rubricIds={rubricIds}
              categoryId={categoryId}
              onClick={onMouseOut}
            />
          ))}
          <li className={s.columnBreak} />
          {apps.map(({ id, name, mob_roundImage }) => (
            <MenuApplicationItem
              key={`app-${id}`}
              id={id}
              logo={mob_roundImage}
              name={name}
              categoryId={categoryId}
              onClick={onMouseOut}
            />
          ))}
        </ul>
        <CategorySubMenuStyle color={color} />
      </div>
      <AdMenu categoryId={categoryId} />
    </div>
  )
}

export default MenuSubCategoriesGE
